import { render, staticRenderFns } from "./PadPresenceTesting.vue?vue&type=template&id=495dd2e0&scoped=true"
import script from "./PadPresenceTesting.vue?vue&type=script&lang=js"
export * from "./PadPresenceTesting.vue?vue&type=script&lang=js"
import style0 from "./PadPresenceTesting.vue?vue&type=style&index=0&id=495dd2e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495dd2e0",
  null
  
)

export default component.exports